export const userActionTypes = {
    SET_MARITAL_STATUS: "SET_MARITAL_STATUS",
    SET_DEPENDENTS: "SET_DEPENDENTS",
    SET_DEPENDENT_LIST: "SET_DEPENDENT_LIST",
    SET_HEALTH_PLAN_DETAILS: "SET_HEALTH_PLAN_DETAILS",
    SET_LEFTOVER_MONEY: "SET_LEFTOVER_MONEY",
    SET_LANGUAGE: "SET_LANGUAGE",
    SET_PLAN_HIGH_DEDUCTIBLE: "SET_PLAN_HIGH_DEDUCTIBLE",
    SET_PAY_COPAYS: "SET_PAY_COPAYS",
    SET_COVERAGE_OPTION: "SET_COVERAGE_OPTION",
    SET_COST_PER_OPTION: "SET_COST_PER_OPTION",
    SET_MODERATE_COVERAGE: "SET_MODERATE_COVERAGE",
    SET_SEVERE_COVERAGE: "SET_SEVERE_COVERAGE",
    SET_CATASTROPHIC_COVERAGE: "SET_CATASTROPHIC_COVERAGE",
    SET_SELECTED_AND_RECOMMENDED_COVERAGE: "SET_SELECTED_AND_RECOMMENDED_COVERAGE",
    SET_SELECT_COST: "SET_SELECT_COST",
    SET_SELECTED_STATE: "SET_SELECTED_STATE",
    SET_STREET_ADDRESS: "SET_STREET_ADDRESS",
    SET_APPARTMENT: "SET_APPARTMENT",
    SET_ZIP_CODE: "SET_ZIP_CODE",
    SET_CITY: "SET_CITY",
    SET_MIDDLE_NAME: "SET_MIDDLE_NAME",
    SET_SUFFIX: "SET_SUFFIX",
    SET_DAYTIME_PHONE: "SET_DAYTIME_PHONE",
    SET_LAST_VISITED_SAVEPOINT_ROUTE: "SET_LAST_VISITED_SAVEPOINT_ROUTE",
    SET_PHONE_TYPE: "SET_PHONE_TYPE",
    SET_BIRTHDATE: "SET_BIRTHDATE",
    SET_ENROLLMENT_RECEIVED_DATE: "SET_ENROLLMENT_RECEIVED_DATE",
    SET_FIRST_NAME: "SET_FIRST_NAME",
    SET_LAST_NAME: "SET_LAST_NAME",
    SET_SSN: "SET_SSN",
    SET_PLAN_CONTRIB_COST: "SET_PLAN_CONTRIB_COST",
    SET_BRELLA_SELECT_TIER_SELECTED: "SET_BRELLA_SELECT_TIER_SELECTED",
    SET_FETCH_PLAN_RECOMMENDATION: "SET_FETCH_PLAN_RECOMMENDATION",
    SET_RESET_TOKEN_EMAIL: "SET_RESET_TOKEN_EMAIL",
    SET_DEPENDENT: "SET_DEPENDENT",
    DELETE_DEPENDENT: "DELETE_DEPENDENT",
    REMOVE_CHILD_IDX: "REMOVE_CHILD_IDX",
    VALID_EMPLOYER_PASSCODE: "VALID_EMPLOYER_PASSCODE",
    VALID_SSN_VERIFICATION: "VALID_SSN_VERIFICATION",
    RESET_USER_DATA: "RESET_USER_DATA",
    OVERWRITE_STATE: "OVERWRITE_STATE",
    SET_ENROLLEESFID: "SET_ENROLLEESFID",
    SET_ALL_ADDRESS_FIELDS: "SET_ALL_ADDRESS_FIELDS",
    SET_ACCOUNT: "SET_ACCOUNT",
    SET_GENDER: "SET_GENDER",
    SET_SKIP_RECOMMENDATION: "SET_SKIP_RECOMMENDATION",
};

export const initialDataActionTypes = {
    SET_INITIAL_DATA: "SET_INITIAL_DATA",
    CLEAR_INITIAL_DATA: "CLEAR_INITIAL_DATA",
    SET_VERIFY_RESPONSE_DATA: "SET_VERIFY_RESPONSE_DATA",
    SET_CENSUS_EE_ADDRESS: "SET_CENSUS_EE_ADDRESS",
    SET_ET_CONTRACT_TERMS_DATA: "SET_ET_CONTRACT_TERMS_DATA",
    SET_IS_MEMBER: "SET_IS_MEMBER",
    SET_ENROLLMENT_DECLINED: "SET_ENROLLMENT_DECLINED"
};

export const appHeaderActionTypes = {
    SET_PREV_ROUTE: "SET_PREV_ROUTE",
    RESET_APP_HEADER_DATA: "RESET_APP_HEADER_DATA",
};

export const benAdminActionTypes = {
    SET_BEN_ADMIN_NAME: "SET_BEN_ADMIN_NAME",
    SET_BEN_ADMIN_LAST_NAME: "SET_BEN_ADMIN_LAST_NAME",
    RESET_BEN_ADMIN_DATA: "RESET_BEN_ADMIN_DATA",
}

export const toastActionTypes = Object.freeze({
    SHOW: 'toast/SHOW',
    HIDE: 'toast/HIDE',
    CLEAR: 'toast/CLEAR',
    RESET: 'toast/RESET'
});
